<template>
  <Base>
    <template v-slot:contentBase>

      <div class="panel panel-success mb-5">

        <div class="panel-heading">
          <h3>
            <i class="fa fa-list-ul"></i>
            {{ listSubtitulo }}
          </h3>
        </div>

        <div class="panel-body">

          <p>
            <slot name="incluirCadastro"></slot>

          </p>

          <p>
            <button v-if="btnFiltro" @click="$emit('update:drawer', true)"
                    class="btn btn-success btn-sm ml-1 font-bold">
              <i class="fa fa-filter"></i> FILTRAR
            </button>
          </p>

          <div class="p-2 flex items-center gap-2 flex-wrap">
            <slot name="toolbar-start"></slot>

            <InputGroup style="width: 10%" v-if="btnPesquisar">
              <FloatLabel variant="on">
                <InputText id="pesquisar" v-model="globalFilter" size="small" placeholder="PESQUISAR..."/>
              </FloatLabel>
              <InputGroupAddon>
                <Button icon="pi pi-search" severity="secondary" variant="text" size="small" @click="onSearch"/>
              </InputGroupAddon>
            </InputGroup>

            <div class="float-right">
              <button @click="exportExcel" class="btn btn-primary btn-sm font-bold ml-1">EXCEL</button>
              <button @click="exportPdf" class="btn btn-danger btn-sm font-bold ml-1">PDF</button>
              <button @click="copyTable" class="btn btn-dark btn-sm font-bold ml-1">COPIAR</button>
              <button @click="printTable" class="btn btn-success btn-sm font-bold ml-1">IMPRIMIR</button>
            </div>

            <slot name="toolbar-end"></slot>
          </div>

          <div class="table-responsive">.

            <DataTable
                :value="data"
                :lazy="true" :paginator="true"
                :rows="lazyParams.rows" :first="lazyParams.first" :totalRecords="totalRecords"
                @page="onPage"
                @sort="onSort"
                :rowsPerPageOptions="[5, 10, 20, 50, 100]"
                :globalFilterFields="globalFilterFields"
                :filters="filters"
                
                class="p-datatable-gridlines"
                ref="dt"
                :loading="loading"
                selectionMode="single"
                :size="data.length > 2 ? 'small' : 'normal'"
                stripedRows
                :scrollable="data.length > 5"
                :scrollHeight="data.length > 5 ? '500px' : null"
            >
              <Column
                  v-for="col in visibleColumns"
                  :key="col.key"
                  :field="col.field"
                  :header="col.header"
                  :sortable="true"
                  :class="col.align"
              >
                <template v-if="col.body" #body="slotProps">
                  <span v-if="col.body(slotProps.data)" v-html="col.body(slotProps.data)"></span>
                </template>
              </Column>

              <!-- Slot opcional para ações customizadas por linha -->
              <Column v-if="$slots.actions" header="AÇÕES">
                <template #body="slotProps">
                  <slot name="actions" v-bind="slotProps"></slot>
                </template>
              </Column>

            </DataTable>
          </div>
        </div>
      </div>

    </template>
  </Base>

</template>

<script>
import Base from './Base.vue';
import {ref, computed, watch, nextTick, onMounted} from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import * as XLSX from 'xlsx';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default {
  name: 'BaseList',
  computed: {
    visibleColumns() {
      return this.columns.filter(col => col.visible !== false)
    },
  },
  components: {
    Column,
    DataTable,
    Base,
  },
  props: {
    listSubtitulo: {
      type: String,
      default: "Lista",
    },
    btnFiltro: {
      type: Boolean,
      required: false,
    },
    btnPesquisar: {
      type: Boolean,
      default: true
    },
    data: {type: Array, required: true},
    columns: {type: Array, required: true},
    globalFilterFields: {type: Array, default: () => []},
    loading: {type: Boolean, default: false},
    totalRecords: {type: Number, default: 0},
  },
  emits: ["update:pagination", "update:drawer"],
  setup(props, {emit}) {
    const globalFilter = ref('');
    const filters = ref({global: {value: null, matchMode: 'contains'}});
    const dt = ref(null);
    const logoBase64 = ref(null);
    const visibleRight = ref(false);

    const lazyParams = ref({
      first: 0,
      rows: 10,
      page: 1,
    });

    const carregarLogoParaPdf = () => {
      const imageUrl = '/img/sgo-logo3.png';

      fetch(imageUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Falha ao buscar imagem: ${response.statusText}`);
            }
            return response.blob();
          })
          .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = () => reject('Erro ao ler blob da imagem');
            reader.readAsDataURL(blob);
          }))
          .then(base64 => {
            logoBase64.value = base64;
          })
          .catch(error => {
            console.error('Erro ao carregar logo para PDF:', error);
            logoBase64.value = null;
          });
    };

    carregarLogoParaPdf();

    const onPage = (event) => {
      // 2.1. ATUALIZA o estado interno (CRUCIAL para o DataTable saber onde está)
      lazyParams.value.first = event.first;
      lazyParams.value.rows = event.rows;

      // 2.2. Calcula o número da página (event.first / event.rows) + 1
      const currentPage = (event.first / event.rows) + 1;
      lazyParams.value.page = currentPage;

      // 2.3. EMITE o evento para o componente pai (ListaMateriais.vue)
      // Esta emissão é que aciona o loadDataLazy no componente pai.
      emit('update:pagination', {
        page: currentPage,
        page_size: event.rows,
      });
    };

    function onSort(event) {
      const {sortField, sortOrder} = event;

      // Cria uma cópia para não modificar diretamente props.data
      const sortedData = [...props.data].sort((a, b) => {
        let valA = a[sortField];
        let valB = b[sortField];

        // Normaliza valores
        if (typeof valA === "string") valA = valA.toLowerCase();
        if (typeof valB === "string") valB = valB.toLowerCase();

        if (valA == null) return 1;
        if (valB == null) return -1;

        if (valA < valB) return -1 * sortOrder;
        if (valA > valB) return 1 * sortOrder;
        return 0;
      });

      // Atualiza o array ordenado no front
      props.data.splice(0, props.data.length, ...sortedData);
    }

    // 3. Emite a primeira requisição ao montar
    onMounted(() => {
      emit('update:pagination', {
        page: lazyParams.value.page,
        page_size: lazyParams.value.rows,
      });
    });

    function onSearch() {
      emit('update:pagination', {
        ...lazyParams.value,
        search: globalFilter.value,
      });
    }

    const visibleRows = computed(() => Math.min(rows.value, props.data.length));

    function exportExcel() {
      const wsData = [props.columns.map((c) => c.header)];
      props.data.forEach((row) => {
        wsData.push(props.columns.map((c) => row[c.field]));
      });
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Export');
      XLSX.writeFile(wb, 'export.xlsx');
    }

    function exportPdf() {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "A4",
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // DADOS DE EXIBIÇÃO: Agora acessa props.listSubtitulo diretamente
      const tituloSistema = "Sistema de Gerenciamento de Obras";
      const tituloRelatorio = props.listSubtitulo || "Relatório de clientes";
      const subtituloFiltros = "Filtros";
      // props.filtros pode ser undefined se você não estiver passando, mas o acesso está correto
      const filtros = props.filtros?.length ? props.filtros.join(", ") : "Nenhum filtro aplicado";
      const dataEmissao = new Date().toLocaleDateString("pt-BR", {year: 'numeric', month: '2-digit', day: '2-digit'});

      const marginX = 40;
      let currentY = 40;

      // --- 1. Logotipo (Lado Esquerdo Superior) ---
      if (logoBase64.value) {
        try {
          doc.addImage(logoBase64.value, 'PNG', marginX, currentY - 25, 80, 80);
        } catch (e) {
          console.error("Erro ao adicionar logo (verifique a string base64):", e);
        }
      }

      // --- 2. Títulos (Centro/Esquerda) ---
      currentY += 10;

      // Título Principal (SGO)
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text(tituloSistema, marginX + 70, currentY, {align: "left"});

      // Subtítulo do Relatório
      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.text(tituloRelatorio, marginX + 70, currentY + 15, {align: "left"});

      // Subtítulo 'Filtros'
      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.text(subtituloFiltros, marginX + 70, currentY + 30, {align: "left"});

      // --- 3. Data de Emissão (Lado Direito Superior) ---
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(80);
      doc.text(`Data de emissão: ${dataEmissao.replace(/\//g, '/')}`, pageWidth - marginX, 40, {align: "right"});

      const startYTable = currentY + 60;

      function stripHtml(html) {
        // Usa RegExp para remover todas as tags HTML
        if (typeof html !== 'string') return html;
        return html.replace(/<[^>]*>?/gm, '').trim();
      }

      // --- 4. Criação da Tabela (jsPDF-AutoTable) ---
      autoTable(doc, {
        startY: startYTable,
        margin: {left: marginX, right: marginX},

        // Usa props.columns e props.data
        head: [props.columns.map((c) => c.header)],
        body: props.data.map((r) => props.columns.map((c) => {
          const value = r[c.field] ?? "";
          // Verifica se o campo é 'status' ou se o valor parece ser HTML para limpar
          if (c.field === 'status' && typeof value === 'string') {
            return stripHtml(value);
          }
          return value;
        })),
        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 3,
          halign: "left",
          valign: "middle",
        },
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: [0, 0, 0],
          fontStyle: "bold",
        },

        didDrawPage: (data) => {
          const pageCount = doc.getNumberOfPages();
          const currentPage = data.pageNumber;

          doc.setFontSize(9);
          doc.setTextColor("#666");

          doc.text(
              `Página ${currentPage} de ${pageCount}`,
              pageWidth / 2,
              pageHeight - 20,
              {align: "center"}
          );
        },
      });

      // --- 5. Salvar arquivo ---
      const nomeArquivo = tituloRelatorio.replace(/\s+/g, "_").toLowerCase();
      doc.save(`${nomeArquivo}_${dataEmissao.replace(/\//g, '-')}.pdf`);
    }

    async function copyTable() {
      let txt = props.columns.map((c) => c.header).join('\t') + '\n';
      props.data.forEach((r) => {
        txt += props.columns.map((c) => String(r[c.field] ?? '')).join('\t') + '\n';
      });
      try {
        await navigator.clipboard.writeText(txt);
        alert('Tabela copiada para a área de transferência');
      } catch (err) {
        const ta = document.createElement('textarea');
        ta.value = txt;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        alert('Tabela copiada (fallback)');
      }
    }

    function printTable() {
      const win = window.open('', '_blank');
      if (!win) return;
      const styles = `<style>table{border-collapse:collapse;width:100%} th,td{border:1px solid #ccc;padding:6px;text-align:left}</style>`;
      let html = '<table><thead><tr>' + props.columns.map((c) => `<th>${c.header}</th>`).join('') + '</tr></thead><tbody>';
      props.data.forEach((r) => {
        html += '<tr>' + props.columns.map((c) => `<td>${r[c.field] ?? ''}</td>`).join('') + '</tr>';
      });
      html += '</tbody></table>';
      win.document.write(styles + html);
      win.document.close();
      win.print();
    }

    // Atualiza os id das linhas
    watch(
        () => props.data,
        () => {
          nextTick(() => {
            const tableBody = document.querySelector('.p-datatable-tbody');
            if (!tableBody) return;

            Array.from(tableBody.children).forEach((tr, index) => {
              const row = props.data[index];
              if (row?.key) {
                tr.id = 'linha_' + row.key;
              } else if (row?.id) {
                tr.id = 'linha_' + row.id;
              }
            });
          });
        },
        {deep: true, immediate: true}
    );

    return {
      globalFilter,
      filters,
      dt,
      visibleRows,
      lazyParams,
      visibleRight,
      onPage,
      onSort,
      onSearch,
      exportExcel,
      exportPdf,
      copyTable,
      printTable,
    };
  },
}
</script>


<style scoped>
.p-inputtext {
  padding: .2rem;
  border: 1px solid #ccc;
  border-radius: 4px
}

</style>

